import { Modal } from "antd";
import { Rule } from "antd/lib/form";
import { useForm } from "antd/lib/form/Form";
import { VoteComponent } from "components/Vote/Vote";
import { useEffect, useState } from "react";
import { News } from "types/news";
const rules: Rule[] = [{ required: true }];

export const VoteModal = ({
  visible,
  selectData,
  onClose,
}: {
  visible: boolean;

  selectData?: Partial<News>;
  onClose: () => void;
}) => {
  const [form] = useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({ ...selectData });
    }
  }, [visible, selectData]);

  return (
    (<Modal
      onCancel={onClose}
      open={visible}
      title={"Thống kê lượt vote"}
      confirmLoading={loading}
      footer={null}
    >
      <VoteComponent newsId={selectData?.id} />
    </Modal>)
  );
};
